import React from 'react';
import style from './pop.module.css';

const Pop = (props) => {
    return (
        <div className={style.popup} >
            <h2>{ props.info[0] }</h2>
            <p dangerouslySetInnerHTML={{ __html: props.info[1] }}></p>
            {props.info[2] && props.info[2].trim() !== '' ? (
                <button
                    className={ `bt small ${props.info[2]==='upload'?'gray':'blue'}` }
                    onClick={props.onClose}
                    disabled={props.info[2] === 'upload'}
                    style={{
                        position: 'absolute', bottom: '5%', left: '50%',
                        transform: 'translate(-50%,0)',
                    }}
                >
                    {props.info[2]}
                </button>
            ) : null}
        </div>
    );
};

export default Pop;